import React from 'react';
import { Divider, Stack, Text } from 'rsuite';
import ReportRevenueInput from "./ReportRevenueInput";

const ReportRevenuePeriod = ({ period, periodRefs }) => (
  <div key={`report_revenue_period_${period.startDate}_${period.endDate}`}>
    <Text className="text-bold mb-12 header-text-h4">{period.label}</Text>
    <Stack direction='column' spacing={30} alignItems='stretch'>
      
      {
        period.licenses?.map((license, licenseIndex) => (
          <ReportRevenueInput
            key={`report_revenue_period_license${period.startDate}_${licenseIndex}`}
            ref={periodRefs[licenseIndex]}
            license={license}
            period={period} /> 
        ))
        
      }
    </Stack>
    <Divider className='bg-bright-zenith'/>
  </div>
);

export default ReportRevenuePeriod;
